<div id="layout-topbar" class="layout-topbar no-print">

    <a routerLink="/" *ngIf="app.isHorizontal() && !app.isMobile()" class="topbar-logo">
        <img alt="logo" src='{{ arquivoLogoPequena }}' />
        <span class="app-name"></span>
    </a>
    <img alt="logo" src='{{ arquivoLogoPequena }}' style="visibility: hidden;" class="mobile-logo"/>

    <!-- 
    app-isHor: {{app.isHorizontal()}}
    app-isMob: {{app.isMobile()}} 
    -->
    <a href="#" class="menu-btn" (click)="app.onMenuButtonClick($event)">
      <i class="material-icons">&#xE5D2;</i>
    </a>

    <a href="#" class="topbar-menu-btn" (click)="app.onTopbarMobileMenuButtonClick($event)">
      <i class="material-icons account-circle-mobile-icon">account_circle</i>
    </a>
    
    <span class="topbar-menu-btn" *ngIf="app.isMobile()">
      <app-topbar-search></app-topbar-search>
    </span>





    <div class="layout-topbar-menu-wrapper">
        <ul class="topbar-menu fadeInDown" [ngClass]="{'topbar-menu-active': app.topbarMenuActive}" (click)="app.onTopbarMenuClick($event)">
            <li #profile class="profile-item" [ngClass]="{'active-topmenuitem': app.activeTopbarItem === profile}" (click)="app.onTopbarRootItemClick($event, profile)">
                <a href="#">
                    <span class="profile-image-wrapper">
                        <!-- <img src="assets/layout/images/avatar.png"/> -->
                        <i class="material-icons">account_circle</i>
                    </span>
                    <div class="topbar-item-name profile-name">
                      <label class="usuario-nome">{{usuario.nome}}</label>
                      <label 
                        *ngIf="usuario.perfil && usuario.perfil.nome"
                        class="perfil-nome" 
                        title="Perfil de acesso">
                        {{usuario.perfil?.nome}}
                      </label>
                    </div>
                </a>
                <ul class="fadeInDown">
                    <li role="menuitem">
                        <a [routerLink]="['/seguranca/usuario-tabmenu/'+usuario.id]">
                            <i class="material-icons">account_circle</i>
                            <span>Meu perfil</span>
                        </a>
                    </li>
                    <!-- <li role="menuitem">
                        <a href="#">
                            <i class="material-icons">verified_user</i>
                            <span>Privacy</span>
                        </a>
                    </li>
                    <li role="menuitem">
                        <a href="#">
                            <i class="material-icons">settings_application</i>
                            <span>Settings</span>
                        </a>
                    </li> -->
                    <li role="menuitem" *ngIf="!isGEEO">
                      <a routerLink="/" (click)="abrirManual()">
                          <i class="material-icons">subject</i>
                          <span>Manual do usuário</span>
                      </a>
                    </li>
                    <li role="menuitem">
                      <a routerLink="/" (click)="irParaReleaseNoteHome()">
                          <i class="material-icons">new_releases</i>
                          <span>Release notes</span>
                      </a>
                    </li>                    
                    <li role="menuitem">
                        <a routerLink="/" (click)="logout()">
                            <i class="material-icons">exit_to_app</i>
                            <span>Logout</span>
                        </a>
                    </li>
                </ul>
            </li>

            <!--
                <li #settings [ngClass]="{'active-topmenuitem':app.activeTopbarItem === settings}" (click)="app.onTopbarRootItemClick($event, settings)">
                    <a href="#">
                        <i class="topbar-icon material-icons">settings</i>
                        <span class="topbar-item-name">Settings</span>
                    </a>
                <ul class="fadeInDown">
                    <li role="menuitem">
                        <a href="#">
                            <i class="material-icons">palette</i>
                            <span>Change Theme</span>
                        </a>
                    </li>
                    <li role="menuitem">
                        <a href="#">
                            <i class="material-icons">star</i>
                            <span>Favorites</span>
                        </a>
                    </li>
                    <li role="menuitem">
                        <a href="#">
                            <i class="material-icons">lock</i>
                            <span>Lock Screen</span>
                        </a>
                    </li>
                    <li role="menuitem">
                        <a href="#">
                            <i class="material-icons">wallpaper</i>
                            <span>Wallpaper</span>
                        </a>
                    </li>
                </ul>
            </li>
            -->

            <!--
            <li #messages [ngClass]="{'active-topmenuitem':app.activeTopbarItem === messages}" (click)="app.onTopbarRootItemClick($event, messages)">
                <a href="#">
                    <i class="topbar-icon material-icons animated swing">&#xE0C9;</i>
                    <span class="topbar-badge animated rubberBand">5</span>
                    <span class="topbar-item-name">Messages</span>
                </a>
                <ul class="fadeInDown">
                    <li role="menuitem">
                        <a href="#" class="topbar-message">
                            <img src="assets/layout/images/avatar1.png" width="35"/>
                            <span>Give me a call</span>
                        </a>
                    </li>
                </ul>
            </li>
            -->

            <li #notifications *ngIf="notificacoes.length > 0" [ngClass]="{'active-topmenuitem':app.activeTopbarItem === notifications}" (click)="app.onTopbarRootItemClick($event, notifications)">
              <a href="#">
                <i class="topbar-icon material-icons">notifications</i>
                <span class="topbar-badge animated rubberBand">{{notificacoes.length}}</span>
                <span class="topbar-item-name">Notifications</span>
              </a>
              <ul class="fadeInDown">
                <ng-container *ngFor="let notificacao of notificacoes">
                  <li role="menuitem" class="card-notificacao">
                    <a href="javascript:void(0);" (click)="clickNotificacao(notificacao)">
                      <!-- <i class="material-icons">info</i> -->
                      <span class="card-notificacao-label">{{notificacao.titulo}}</span>
                    </a>
                  </li>
                </ng-container>
              </ul>
            </li>

            <li *ngIf="urlDoFormularioDeFeedback">
              <a href="{{ urlDoFormularioDeFeedback }}" target="_blank">
                <i class="material-icons feedback-icon" title="Feedback">tips_and_updates</i>
                <span class="topbar-item-name">Feedback</span>
              </a>
            </li>

            <li class="topbar-search" *ngIf="!app.isMobile()">
              <app-topbar-search></app-topbar-search>
            </li>            
           
        </ul>
    </div>
</div>
